import { guideSteps } from "@/mocks/manga";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 uppercase tracking-widest">
              <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
              How to Start
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              追更与补番指南
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              第一次来不知道怎么下手？按下面四步走，基本上五分钟就能从「随便看看」
              变成「我知道接下来要看哪几部」。
            </p>
          </div>

          <div className="lg:col-span-8">
            <ol className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {guideSteps.map((step) => (
                <li
                  key={step.step}
                  className="p-5 rounded-lg bg-background-50 border border-background-200"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <span className="font-heading text-3xl font-black text-background-300">
                      {step.step}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {step.text}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}